<template>
  <div class="acomodar">
    <Dispositivos />
  </div>
</template>

<script>
import Dispositivos from "@/components/ModTecnologia/Dispositivos/Dispositivos.vue";
export default {
  name: "CopiasDispositivos",
  components: {
    Dispositivos,
  },
  data() {
    return {};
  },

  mounted() {},

  created() {
    this.cambiarEstadoNavbar()
  },

  methods: {
    cambiarEstadoNavbar() {
    //   // Acción directa para cambiar el estado del navbar a true
     this.$store.dispatch("acciones/CambioNavbar", true);
     },
  },
};
</script>


